import { inject, Injectable } from "@angular/core";
import { BaseHttpService } from "../../services/common/base.http.service";
import { DistanceModel, GroupedDistanceModel } from "../models/distance.model";
import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { administrationConst } from "../administration.const";
import { ResultInfo } from "../../shared/models/result-info.model";
import { ManageDistanceModel } from "../models/manage-distance.model";
import { SearchParameters } from "../../shared/models/searchParameters.model";
import { SearchDistanceChangesModel } from "../models/search-distance-changes.model";
import { PagedResult } from "../../shared/models/pagedResult.model";
import { DistanceChangesModel } from "../models/distance-chanes.model";

@Injectable({
    providedIn: 'root'
  })
  export class DistanceService {
    baseHttpService = inject(BaseHttpService);
        
    getAllDistances(): Observable<GroupedDistanceModel[]> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.baseHttpService.get<GroupedDistanceModel[]>(administrationConst.distance, { headers: headers });
    }   

    getTowns(town?: string): Observable<string[]> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      const params = town ? `?town=${town}` : '';
      return this.baseHttpService.get<string[]>(`${administrationConst.town}${params}`, { headers });
    }

    getDistance(from: string, to: string): Observable<DistanceModel> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      const params = `?from=${from}&to=${to}`;
      return this.baseHttpService.get<DistanceModel>(`${administrationConst.townDistance}${params}`, { headers });
    }


    addDistance(data: ManageDistanceModel): Observable<ResultInfo> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.baseHttpService.post<ResultInfo>(administrationConst.distance, data, { headers: headers });
    }

    updateDistance(data: ManageDistanceModel): Observable<ResultInfo> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.baseHttpService.put<ResultInfo>(administrationConst.distance, data, { headers: headers });
    }

    deleteDistance(data: ManageDistanceModel): Observable<ResultInfo> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const params = `?from=${data.from}&to=${data.to}`;
        return this.baseHttpService.delete<ResultInfo>(administrationConst.distance + params,  { headers: headers });
    }

    SeachDistanceChanges(searchParameters: SearchParameters<SearchDistanceChangesModel>): Observable<PagedResult<DistanceChangesModel[]>> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.baseHttpService.post<PagedResult<DistanceChangesModel[]>>(administrationConst.distanceChanges, searchParameters, { headers: headers });
    } 
    
  }